var _path, _ellipse, _ellipse2, _path2, _ellipse3, _ellipse4, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHippoicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 67,
    viewBox: "0 0 65 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.16478 1.8891C3.91788 5.90496 7.28823 7.91289 10.0968 9.41882C3.80553 22.2695 4.4796 38.8684 5.60306 45.5615C6.36139 50.0793 9.1981 53.9948 32.5659 57.6091C55.9336 61.2233 59.1542 32.008 57.8435 16.9486C61.2138 16.9486 66.8311 11.9287 63.4608 6.90893C60.7645 2.89308 53.7242 6.23962 50.5411 8.41487C39.3066 -0.0184179 23.7655 2.22375 17.961 4.399C16.2758 1.8891 13.6646 0.722378 12.9055 0.383175L12.9055 0.383172C11.782 -0.118803 7.5176 -0.52878 6.16478 1.8891Z",
    fill: "#D9D9D9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.1501,
    cy: 24.5102,
    rx: 2.58,
    ry: 2.58,
    fill: "#464646"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.06,
    cy: 21.9301,
    rx: 2.58,
    ry: 2.58,
    fill: "#464646"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6903 40.6857C56.0207 30.8123 46.1969 27.6328 31.6811 25.8949C13.4264 23.7094 5.51602 25.8949 1.25659 36.8224C-2.39437 48.8427 0.613927 62.7593 27.8743 65.819C55.1347 68.8787 59.1101 50.3384 57.6903 40.6857Z",
    fill: "#D9D9D9"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.19052,
    cy: 1.68228,
    rx: 1.19052,
    ry: 1.68228,
    transform: "matrix(0.901654 -0.432459 0.511257 0.859428 8.5188 51.2961)",
    fill: "#ABABAB"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.18595,
    cy: 1.68952,
    rx: 1.18595,
    ry: 1.68952,
    transform: "matrix(0.882841 0.469672 -0.550748 0.834671 45.1277 53.8599)",
    fill: "#ABABAB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6299 7.74015C58.6827 6.86595 54.7519 9.69027 53.5349 10.9652C55.4699 12.2552 56.1149 13.5452 57.198 15.4901C59.632 14.7523 61.4575 13.8417 62.0659 12.5668C62.6744 11.4741 62.5771 8.61435 60.6299 7.74015Z",
    fill: "#E7A096"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73999 4.51531C7.35865 6.13503 9.44305 7.84531 10.965 8.38532C12.255 6.45032 13.2507 5.5854 14.835 5.16032C14.4004 3.85438 12.342 2.68501 10.965 2.58032C9.76395 2.42839 8.12134 2.8956 7.73999 4.51531Z",
    fill: "#E7A096"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHippoicon);
export default __webpack_public_path__ + "static/media/hippoicon.b90d12a006246636a9b5c7ad60019bc2.svg";
export { ForwardRef as ReactComponent };